import React from 'react';
import { FadeUp } from './ui/FadeUp';
export function HowItWorksSection() {
  const steps = [{
    number: '01',
    title: 'Intro Call',
    description: 'We learn about your team, structure, and current HR challenges.'
  }, {
    number: '02',
    title: 'Setup & Systems',
    description: 'We organize your HR foundation — policies, workflows, documentation, and manager support.'
  }, {
    number: '03',
    title: 'Ongoing Support',
    description: 'Your team gets continuous HR help through Slack, email, and structured workflows.'
  }];
  return <section id="how-it-works" className="py-28 bg-section-gray" data-id="element-200">
      <div className="max-w-[1240px] mx-auto px-8" data-id="element-201">
        <FadeUp className="mb-16" data-id="element-202">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-203">
            Simple. Structured. Reliable.
          </h2>
        </FadeUp>

        <div className="relative" data-id="element-204">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-8 left-8 right-8 h-px bg-[#e8e8e8] z-0" data-id="element-205"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-206">
            {steps.map((step, index) => <FadeUp key={index} delay={index * 0.15} className="relative" data-id="element-207">
                <div className="bg-white w-16 h-16 rounded-xl border border-[#eee] shadow-[0_10px_30px_rgba(0,0,0,0.05)] flex items-center justify-center mb-6" data-id="element-208">
                  <span className="text-2xl font-bold text-gradient" data-id="element-209">
                    {step.number}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-210">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-211">
                  {step.description}
                </p>
              </FadeUp>)}
          </div>
        </div>
      </div>
    </section>;
}